import get from "lodash/fp/get";
import castArray from "lodash/fp/castArray";

import createRecipe from "./createRecipe";
import createImage from "./createImage";

export default function createRecipeAndImage({
  userChoiceValues,
  signal,
  images: initialImages, // can be an object with key of `images` or an array of objects with the key of `images`
}) {
  const imagesArray = castArray(initialImages);

  return Promise.all([
    createRecipe({ signal })({
      userChoiceValues,
    }).then(get(["Item", "recipeID", "S"])),

    ...imagesArray.map(({ imageSet, images }) =>
      createImage({ signal })({ images }).then((finalImage) => ({
        imageSet,
        finalImage,
      }))
    ),
  ]).then(([recipeID, ...finalImages]) => {
    return { recipeID, finalImages };
  });
}
